import React, {forwardRef} from "react";
import moment from "moment-timezone";

const CustomDateRangeInput = forwardRef(({ onClick, startDate, endDate }, ref) => {
    let displayValue = "Select a date range";

    if (startDate && endDate) {
        const startStr = moment(startDate).format("MMM D, YYYY");
        const endStr = moment(endDate).format("MMM D, YYYY");
        displayValue = startStr === endStr ? startStr : `${startStr} - ${endStr}`;
    }

    return (
        <button type="button" className="date-picker-input" onClick={onClick} ref={ref}>
            {displayValue}
        </button>
    );
});

export default React.memo(CustomDateRangeInput);